<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M8.156,23.988c-0.676,0-1.323-0.25-1.822-0.704c-0.598-0.544-0.92-1.32-0.883-2.128l0.072-1.404
		c0.034-0.665-0.479-1.234-1.144-1.269c-0.021-0.001-0.042-0.002-0.062-0.002c-0.021,0-0.041,0-0.062,0.002l-1.401,0.071
		c-0.047,0.002-0.096,0.004-0.144,0.004c-0.668,0-1.311-0.247-1.809-0.696c-0.537-0.484-0.854-1.148-0.892-1.871
		c-0.043-0.817,0.281-1.6,0.887-2.149l1.042-0.94c0.239-0.216,0.38-0.513,0.397-0.836c0.016-0.323-0.094-0.633-0.31-0.873
		c-0.027-0.03-0.056-0.059-0.087-0.087L0.896,10.16C0.36,9.674,0.046,9.009,0.011,8.286C-0.025,7.564,0.224,6.871,0.71,6.335
		C1.222,5.77,1.952,5.446,2.712,5.446c0.044,0,0.089,0.001,0.133,0.003l1.402,0.071C4.268,5.522,4.31,5.522,4.31,5.522
		c0.644,0,1.174-0.503,1.208-1.144c0.002-0.042,0.002-0.085,0-0.127L5.451,2.845C5.381,1.352,6.538,0.081,8.03,0.011
		c0.043-0.002,0.086-0.003,0.129-0.003c0.76,0,1.489,0.323,2.001,0.886l0.941,1.039c0.217,0.241,0.513,0.382,0.835,0.399
		c0.022,0.001,0.044,0.002,0.066,0.002c0.301,0,0.579-0.107,0.805-0.31c0.031-0.028,0.06-0.057,0.087-0.088l0.95-1.042
		c0.483-0.535,1.148-0.85,1.871-0.887c0.046-0.002,0.091-0.003,0.136-0.003c0.673,0,1.319,0.248,1.818,0.699
		c0.607,0.548,0.931,1.331,0.889,2.148l-0.071,1.4c-0.033,0.665,0.481,1.233,1.146,1.267c0.021,0.001,0.041,0.002,0.061,0.002
		c0.019,0,0.038,0,0.057-0.001l1.4-0.071c0.047-0.002,0.092-0.003,0.138-0.003c0.672,0,1.316,0.249,1.815,0.702
		c0.536,0.486,0.851,1.152,0.887,1.874c0.04,0.815-0.284,1.596-0.889,2.143l-1.042,0.94c-0.239,0.216-0.38,0.513-0.396,0.836
		c-0.017,0.323,0.094,0.633,0.31,0.872c0.028,0.031,0.056,0.06,0.086,0.086l1.042,0.941c0.537,0.485,0.853,1.15,0.89,1.873
		c0.037,0.723-0.21,1.417-0.695,1.953c-0.513,0.567-1.247,0.892-2.015,0.892c0,0,0,0,0,0c-0.043,0-0.087-0.001-0.131-0.003
		l-1.402-0.071c-0.022-0.001-0.044-0.002-0.066-0.002c-0.302,0-0.58,0.108-0.806,0.311c-0.24,0.216-0.381,0.512-0.397,0.835
		c-0.002,0.041-0.002,0.083,0,0.125l0.071,1.4c0.032,0.725-0.219,1.418-0.708,1.953c-0.489,0.535-1.156,0.847-1.878,0.879
		c-0.043,0.002-0.088,0.003-0.133,0.003c-0.75,0-1.474-0.321-1.986-0.88l-0.944-1.044c-0.229-0.253-0.556-0.398-0.899-0.398
		c-0.3,0-0.587,0.11-0.809,0.311c-0.03,0.027-0.06,0.056-0.087,0.087l-0.946,1.042C9.649,23.666,8.918,23.988,8.156,23.988z
		 M4.317,16.982c0.046,0,0.092,0.001,0.138,0.004c1.492,0.077,2.643,1.353,2.566,2.844l-0.072,1.4
		c-0.016,0.357,0.127,0.703,0.394,0.946c0.226,0.206,0.507,0.314,0.812,0.314c0.02,0,0.039,0,0.059-0.001
		c0.322-0.015,0.62-0.155,0.837-0.394l0.944-1.04c0.06-0.067,0.125-0.132,0.193-0.194c0.499-0.45,1.143-0.698,1.815-0.698
		c0.766,0,1.499,0.325,2.012,0.892l0.941,1.041c0.226,0.247,0.552,0.389,0.896,0.389l0.049-0.001
		c0.664-0.03,1.182-0.596,1.152-1.262l-0.071-1.395c-0.005-0.092-0.005-0.185,0-0.278c0.037-0.722,0.353-1.387,0.89-1.871
		c0.499-0.45,1.141-0.698,1.809-0.698c0.048,0,0.096,0.001,0.145,0.004l1.399,0.071c0.024,0.001,0.047,0.002,0.069,0.002
		c0.336,0,0.66-0.145,0.889-0.399c0.217-0.24,0.327-0.55,0.311-0.872c-0.016-0.323-0.157-0.619-0.397-0.836l-1.042-0.94
		c-0.068-0.061-0.133-0.126-0.195-0.195c-1.001-1.108-0.914-2.825,0.195-3.827l1.042-0.94c0.27-0.244,0.414-0.592,0.396-0.956
		c-0.016-0.323-0.156-0.62-0.396-0.837c-0.223-0.202-0.51-0.313-0.809-0.313c-0.021,0-0.041,0.001-0.062,0.002l-1.399,0.071
		c-0.044,0.002-0.089,0.003-0.133,0.003c-0.046,0-0.092-0.001-0.137-0.004c-1.491-0.075-2.643-1.349-2.568-2.84l0.071-1.401
		c0.019-0.365-0.126-0.714-0.397-0.958c-0.226-0.205-0.503-0.312-0.802-0.312c-0.022,0-0.045,0.001-0.068,0.002
		c-0.324,0.016-0.621,0.157-0.837,0.397l-0.948,1.04c-0.059,0.066-0.126,0.133-0.196,0.196c-0.498,0.449-1.142,0.696-1.814,0.696
		c-0.046,0-0.092-0.001-0.138-0.003c-0.723-0.038-1.387-0.354-1.871-0.891L9.05,1.902c-0.228-0.25-0.554-0.394-0.894-0.394
		c-0.019,0-0.038,0-0.057,0.001C7.434,1.54,6.918,2.108,6.949,2.774l0.067,1.4c0.005,0.091,0.005,0.187,0,0.283
		C6.94,5.895,5.752,7.022,4.311,7.022c-0.047,0-0.094-0.001-0.141-0.004L2.771,6.948C2.753,6.947,2.733,6.946,2.714,6.946
		c-0.339,0-0.665,0.145-0.893,0.396c-0.217,0.239-0.328,0.548-0.312,0.87c0.016,0.322,0.156,0.619,0.395,0.836l1.041,0.945
		c0.067,0.061,0.132,0.125,0.193,0.194c1.001,1.109,0.914,2.826-0.195,3.827l-1.041,0.94c-0.27,0.244-0.414,0.594-0.395,0.958
		c0.017,0.322,0.158,0.619,0.398,0.835c0.222,0.2,0.509,0.31,0.807,0.31c0.021,0,0.043,0,0.064-0.002l1.401-0.071
		C4.224,16.983,4.27,16.982,4.317,16.982z"/>
	<path d="M12,17.25c-2.895,0-5.25-2.355-5.25-5.25S9.105,6.75,12,6.75s5.25,2.355,5.25,5.25S14.895,17.25,12,17.25z M12,8.25
		c-2.068,0-3.75,1.682-3.75,3.75s1.682,3.75,3.75,3.75s3.75-1.682,3.75-3.75S14.068,8.25,12,8.25z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'cog',
    },
    name: {
      type: String,
      required: false,
      default: 'Cog',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>